export const allowFitOnLanguage = () => {
  return true
}
